"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_native_1 = require("react-native");
var hooks_1 = require("./hooks");
(function () {
    if (react_native_1.Platform.OS !== 'web')
        return;
    var style = document.createElement('style');
    style.textContent = "\n    ::-webkit-scrollbar {\n      width: 8px;\n      cursor: grab;\n    }\n    ::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.3); \n      border-radius: 5px;\n    }\n  \n    ::-webkit-scrollbar-thumb {\n      border-radius: 5px;\n      -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.5); \n    }\n    * {\n      scrollbar-width: thin;\n      scrollbar-color: dark;\n    }\n  ";
    document.head.append(style);
})();
var Scroll = function (props) {
    var horizontal = props.horizontal, children = props.children, onHoverStyle = props.onHoverStyle, onResponsiveStyle = props.onResponsiveStyle, showIndicator = props.showIndicator, scrollViewProps = props.scrollViewProps, onScroll = props.onScroll;
    var style = hooks_1.usePropsStyle(props);
    var compRef = react_1.useRef(null);
    var onRef = function (ref) {
        compRef.current = ref;
        if (props.onRef)
            props.onRef(ref);
    };
    var useNativeStyleProps = props.useNativeStyleProps === false ? false : true;
    var _a = hooks_1.useHoverStyle(onHoverStyle, useNativeStyleProps, style, compRef), hoverProps = _a[0], combinedStyle = _a[1];
    var responsiveStyle = hooks_1.useResponsiveStyle(onResponsiveStyle);
    var defaultShowIndicator = showIndicator !== undefined ? showIndicator : react_native_1.Platform.select({
        ios: false,
        android: false,
        web: true,
    });
    var scrollIndicatorProps = horizontal ? {
        showsHorizontalScrollIndicator: defaultShowIndicator,
    } : {
        showsVerticalScrollIndicator: defaultShowIndicator,
    };
    return (react_1.default.createElement(react_native_1.ScrollView, __assign({ ref: onRef, horizontal: horizontal }, scrollIndicatorProps, hoverProps, { contentContainerStyle: [combinedStyle, responsiveStyle], keyboardShouldPersistTaps: "always", onScroll: onScroll }, scrollViewProps), children));
};
exports.default = Scroll;
//# sourceMappingURL=Scroll.js.map